import type {TooltipProps as ChakraTooltipProps} from '@chakra-ui/react';
import {Tooltip as ChakraTooltip, forwardRef} from '@chakra-ui/react';

export type TooltipProps = ChakraTooltipProps;

export const Tooltip = forwardRef<TooltipProps, 'div'>(({children, ...props}, ref) => {
  return (
    <ChakraTooltip hasArrow ref={ref} {...props}>
      <span style={{display: `inline-block`}}>{children}</span>
    </ChakraTooltip>
  );
});
